module.exports = __webpack_public_path__ + "img/attack_smalldarkdragon.366aaa35.png";